/*
 * @Author: Vanny
 * @Date: 2019-07-11 09:29:59
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-06 15:59:32
 * @Description: 路由和侧边栏
 */
import LazyLoad from 'src/components/LazyLoad';
import { isProdTest, isProd } from '../utils';
import { isDev, isMC } from '../utils/env';
import { initConfig } from 'src/stores/module/relative';
import { initBillConfig } from 'src/stores/module/bill';

export const baseRoutePath = isMC() ? '/mc' : '/v2';

const routes = [
  {
    path: baseRoutePath,
    auth: true,
    children: [
      {
        path: '/',
        title: 'data_statistics',
        icon: 'dashboard',
        name: 'Dashboard', // 多语言的 componentName
        menu: true, // 代表是侧边栏导航
        meta: { type: 'dashboard/setState', payload: { exist: false } },
        component: LazyLoad(() => import('./dashboard/Dashboard')),
        authority: ['admin', 'manager','sale'],
      },
      {
        menu: true,
        icon: 'product',
        name: 'good',
        path: '/good',
        title: 'goods',
        authority: ['admin', 'manager', 'ProductManager','sale'],
        children: [
          {
            path: '/good-manage',
            name: 'GoodManage',
            title: 'goods',
            meta: { type: 'good/setState', payload: { exist: false } },
            component: LazyLoad(() => import('./good/GoodManage')),
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            path: '/good-import',
            name: 'Import',
            title: 'goodUpload',
            component: LazyLoad(() => import('./good/GoodImport')),
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            path: '/import-purchase',
            name: 'ImportPurchase',
            title: 'import_purchase',
            component: LazyLoad(() => import('./good/ImportPurchase')),
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            path: '/import-pre-sale',
            name: 'ImportPreSaleDoc',
            title: 'import_pre_sell_doc',
            component: LazyLoad(() => import('./good/ImportPreSale')),
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
        ],
      },
      {
        menu: true,
        icon: 'relationship',
        name: 'Relative',
        title: 'relative',
        authority: ['admin', 'manager','sale'],
        children: [
          {
            path: '/relative/customer',
            name: 'Client',
            title: 'Client',
            meta: { type: 'relative/setState', payload: { customer: { ...initConfig } } },
            component: LazyLoad(() => import('./relative/Customer')),
            authority: ['admin', 'manager','sale'],
          },
          {
            path: '/relative/supplier',
            name: 'supplier',
            title: 'supplier_',
            meta: { type: 'relative/setState', payload: { supplier: { ...initConfig } } },
            component: LazyLoad(() => import('./relative/Supplier')),
            authority: ['admin', 'manager','sale'],
          },
          {
            path: '/relative-import',
            name: 'Import',
            title: 'relativeUpload',
            component: LazyLoad(() => import('./relative/RelativeImport')),
            authority: ['admin', 'manager','sale'],
          },
        ],
      },
      {
        menu: true,
        path: '/bill',
        icon: 'order',
        title: 'bill',
        name: 'Bill',
        authority: ['admin', 'manager', 'ProductManager','sale'],
        children: [
          {
            path: '/all',
            name: 'billAll',
            title: 'all_bill',
            component: LazyLoad(() => import('./bill/order/All')),
            meta: { type: 'bill/setState', payload: { all: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'retailSale',
            title: 'retail_bill,+,sale_bill',
            pluginId: '192',
            path: '/retailSale',
            component: LazyLoad(() => import('./bill/order/RetailSale')),
            meta: { type: 'bill/setState', payload: { retailSale: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'retail',
            title: 'retail_bill',
            pluginId: '192',
            path: '/retail',
            component: LazyLoad(() => import('./bill/order/Retail')),
            meta: { type: 'bill/setState', payload: { retail: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'sale',
            title: 'sale_bill',
            path: '/sale',
            component: LazyLoad(() => import('./bill/order/Sale')),
            meta: { type: 'bill/setState', payload: { sale: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'purchase',
            title: 'purchase_bill',
            path: '/purchase',
            component: LazyLoad(() => import('./bill/order/Purchase')),
            meta: { type: 'bill/setState', payload: { purchase: { ...initBillConfig } } },
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            name: 'returnGood',
            title: 'return_good_bill',
            path: '/returnGood',
            component: LazyLoad(() => import('./bill/order/ReturnGood')),
            meta: { type: 'bill/setState', payload: { returnGood: { ...initBillConfig } } },
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            name: 'returnFactory',
            title: 'return_factory_bill',
            path: '/returnFactory',
            component: LazyLoad(() => import('./bill/order/ReturnFactory')),
            meta: { type: 'bill/setState', payload: { returnFactory: { ...initBillConfig } } },
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            name: 'spending',
            title: 'spending_bill',
            path: '/spending',
            component: LazyLoad(() => import('./bill/order/Spending')),
            meta: { type: 'bill/setState', payload: { spending: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'advanceSale',
            title: 'advance_sale_bill',
            path: '/advanceSale',
            component: LazyLoad(() => import('./bill/order/AdvanceSale')),
            meta: { type: 'bill/setState', payload: { advanceSale: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'advanceOrder',
            title: 'advance_order_bill',
            path: '/advanceOrder',
            component: LazyLoad(() => import('./bill/order/AdvanceOrder')),
            meta: { type: 'bill/setState', payload: { advanceOrder: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'transferOrderOut',
            title: 'transfer_order_out',
            path: '/transferOrderOut',
            component: LazyLoad(() => import('./bill/order/TransferOrderOut')),
            meta: { type: 'bill/setState', payload: { transferOrderOut: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'transferOrderIn',
            title: 'transfer_order_in',
            path: '/transferOrderIn',
            component: LazyLoad(() => import('./bill/order/TransferOrderIn')),
            meta: { type: 'bill/setState', payload: { transferOrderIn: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'inventory',
            title: 'inventory_bill',
            path: '/inventory',
            component: LazyLoad(() => import('./bill/order/Inventory')),
            meta: { type: 'bill/setState', payload: { inventory: { ...initBillConfig } } },
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            name: 'cashier',
            title: 'cashier_bill',
            path: '/cashier',
            component: LazyLoad(() => import('./bill/order/Cashier')),
            meta: { type: 'bill/setState', payload: { cashier: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
          {
            name: 'bhb',
            title: isMC() ? 'i_weshop,order' : '补货宝会员订单',
            path: '/bhb',
            pluginId: '191',
            component: LazyLoad(() => import('./bill/order/BHB')),
            meta: { type: 'bill/setState', payload: { bhb: { ...initBillConfig } } },
            authority: ['admin', 'manager','sale'],
          },
        ],
      },
      {
        path: '/finance',
        icon: `${isMC() ? 'mc_' : ''}finance`,
        title: 'finance',
        name: 'Finance',
        menu: true,
        component: LazyLoad(() => import('./finance/FinanceManage')),
        meta: { type: 'finance/setState', payload: { exist: false } },
        authority: ['admin', 'manager','sale'],
      },
      {
        menu: isMC(),
        icon: 'report',
        name: 'export',
        path: '/export',
        title: 'export',
        authority: ['admin', 'manager','sale'],
        component: LazyLoad(() => import('./statistics/export')),
      },
      {
        menu: !isMC(),
        icon: 'report',
        name: 'statistics',
        path: '/statistics',
        title: isProdTest() ? '报表测试' : 'report',
        // pluginId: isProdTest() ? '219' : '215',
        tab: (n) => `报表收藏夹${n ? `(${n})` : ''}`,
        authority: ['admin', 'manager','sale'],
        component: LazyLoad(() => import('./statistics/list')),
      },
      {
        menu: !isMC() || (isMC() && !isProd()),
        icon: 'history',
        name: 'importExport',
        title: 'import_export',
        className: 'upload-down-center',
        authority: ['admin', 'manager', 'ProductManager','sale'],
        children: [
          {
            hideTab: 1,
            name: 'center-upload',
            title: 'import_history',
            meta: { type: 'down/setState', payload: { visible: true, temp: 1 } },
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
          {
            hideTab: 1,
            name: 'center-down',
            title: 'export_history',
            meta: { type: 'down/setState', payload: { visible: true, temp: 0 } },
            authority: ['admin', 'manager', 'ProductManager','sale'],
          },
        ],
      },
    ],
  },
  // 未使用
  // {
  //   path: '/back-auth',
  //   title: '校验中...',
  //   name: 'BackAuth',
  //   component: LazyLoad(() => import('./login/BackNv')),
  // },
  {
    path: '/login',
    title: 'login',
    name: 'Login',
    component: LazyLoad(() => import('./login/Login')),
  },
  {
    path: '/',
    title: '',
    redirect: '/login',
  },
];

export const getMenus = () => {
  const cycleMenus = (routes, route) => {
    return routes.reduce((acc, sub, i) => {
      // 是否是待开发模块
      if (!isDev() && sub.dev) return acc;

      // 如果是 menu
      if (sub.menu) {
        const { menu, name, path, title, children, ...subProps } = sub;
        const menuItem = {
          ...subProps,
          name: title || name,
        };
        if (!sub.children || sub.component) {
          menuItem.path = sub.path ? `${route?.path || ''}${sub.path || ''}` : '';
        }
        if (sub.children) {
          menuItem.children = sub.children
            .filter((s) => (isDev() || !s.dev) && s.menu !== false)
            .map(({ title, ...s }) => ({
              ...s,
              name: title || s.name,
              path: s.path
                ? `${route?.path || ''}${sub.path || ''}${s.path || ''}`.replace(
                    /\/:[a-z]+\//g,
                    '/'
                  )
                : '',
            }));
        }
        acc.push(menuItem);
      } else if (sub.children) {
        acc.push(...cycleMenus(sub.children, sub));
      }

      return acc;
    }, []);
  };

  return cycleMenus(routes, null);
};

const routeList = (() => {
  const cycleRoutes = (routes, route) => {
    if (!route) {
      return routes.map((r) => (r.children ? { ...r, children: cycleRoutes(r.children, r) } : r));
    }
    return routes.reduce((acc, sub) => {
      const path = `${route?.path || ''}${sub.path || ''}`;
      if (sub.component) {
        acc.push({ ...sub, path, key: route.name });
      } else if (sub.children) {
        acc.push(...cycleRoutes(sub.children, { ...sub, path, key: route.name }));
      }
      return acc;
    }, []);
  };
  return cycleRoutes(routes, null);
})();

export const routeNames = routeList.reduce(
  (acc, route) => (
    route.children
      ? route.children.forEach((r) => (acc[r.name] = r.path))
      : (acc[route.name] = route.path),
    acc
  ),
  {}
);

export default routeList;
